import { consoleTracker } from './gtm/consoleTracker';
import { gtmTracker } from './gtm/gtmTracker';
import { makeTracker } from './makeTracker';
import { TTracker } from './TTracker';

const trackers: TTracker[] = [gtmTracker, consoleTracker, makeTracker].filter(
    t => t.isEnabled(),
);

export const tracker: TTracker = {
    isEnabled: () => true,
    trackPageView(...args) {
        trackers.map(tracker => tracker.trackPageView(...args));
    },
    trackEvent(...args) {
        trackers.map(tracker => tracker.trackEvent(...args));
    },
    init() {
        trackers.map(tracker => tracker.init?.());
    },
};
